module.exports = __webpack_public_path__ + "static/media/man.be37cdd8.png";